import React from 'react'
import "./Partners.css"
import partner from "../Assets/p1.png"
import partner2 from "../Assets/p2.png"
import partner3 from "../Assets/p3.png"
import partner4 from "../Assets/p4.png"
import partner5 from "../Assets/p5.png"
import partner6 from "../Assets/p6.png"
import partnerr from "../Assets/partner.png"

export default function Partners() {
  return (
    <div className='bg_partners'>
    <div className=''>
    {/* <div className="container">
        <div className="row align-items-center">
            <div className="col-md-2 col-6  my-3">
                <img src={partner}  className='w-100'  alt="" />
            </div>
            <div className="col-md-2 col-6  my-3">
                <img src={partner2}   className='w-100' alt="" />
            </div>
            <div className="col-md-2 col-6  my-3">
                <img src={partner3}  className='w-100'  alt="" />
            </div>
            <div className="col-md-2 col-6  my-3">
                <img src={partner4}  className='w-100'  alt="" />
            </div>
            <div className="col-md-2 col-6  my-3">
                <img src={partner5}  className='w-100'  alt="" />
            </div>
            <div className="col-md-2 col-6  my-3">
                <img src={partner6}  className='w-100'  alt="" />
            </div>
        </div>
    </div> */}
    <img src={partnerr} className='w-100' alt="" />
    </div>
    </div>
    
  )
}
